import useFrame from '~/services/umbraco/hooks/useFrame';

export default function useCulture() {
    return useFrame((data) => data?.culture);
}
